import { ScrollToTop } from "@/shared/lib/ScrollToTop";
import { replaceEmptyStringWithUndefined } from "@/shared/lib/object";
import {
  customZodResolver,
  useSubscribeFromValues,
} from "@/shared/lib/react-hook-form";
import { BaseButton } from "@/shared/ui/BaseButton";
import { BaseBreadCrumb } from "@/shared/ui/base-bread-crumb";
import { BaseMessageCard } from "@/shared/ui/base-message-card";
import {
  Box,
  CircularProgress,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import { useForm } from "react-hook-form";
import type { MasterDataVehicleCreatePageProps } from "../../model";
import {
  type CreateMasterDataVehicleFormSchemaType,
  createMasterDataVehicleFormSchema,
} from "../../model/validation";
import { MasterDataVehicleForm } from "./form/master-data-vehicle-form";

export const MasterDataVehicleCreateInProgress = (
  props: MasterDataVehicleCreatePageProps,
) => {
  const links = [
    { href: "/master-data/vehicles", label: "車両管理" },
    { label: "車両新規登録" },
  ];

  const { handleSubmit, ...form } =
    useForm<CreateMasterDataVehicleFormSchemaType>({
      resolver: customZodResolver(createMasterDataVehicleFormSchema),
      mode: "onChange",
      defaultValues: props.defaultInputValues ?? {},
    });
  useSubscribeFromValues((values) => {
    props.onInputValuesUpdate(replaceEmptyStringWithUndefined(values));
  }, form.watch);

  const hasError = Object.keys(form.formState.errors).length > 0;
  return (
    <Box px={{ xs: 2, sm: 4 }}>
      <ScrollToTop />
      <BaseBreadCrumb links={links} />
      <Box
        mt={3}
        pb={3}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
          }}
        >
          車両新規登録
        </Typography>
      </Box>

      <Box
        display="flex"
        mx={-4}
        bgcolor="grey.50"
        flexDirection={"column"}
        flexGrow={1}
      >
        <Container maxWidth="md">
          <Stack
            pt={{ xs: 2, sm: 6 }}
            pb={{ xs: 4, sm: 4 }}
            px={{ xs: 2, sm: 0 }}
          >
            {props.offices.status === "loading" ? (
              <Stack>
                <CircularProgress />
              </Stack>
            ) : props.offices.status === "error" ? (
              <BaseMessageCard
                status={"error"}
                message={"事業所の取得に失敗しました。"}
              />
            ) : (
              <MasterDataVehicleForm
                offices={props.offices.data}
                control={form.control}
              />
            )}
          </Stack>
        </Container>
      </Box>
      <Stack justifyContent="center" alignItems="center" spacing={2} py={2}>
        {hasError ? (
          <BaseMessageCard
            status={"error"}
            message={"必須項目が入力されていない箇所があります。"}
          />
        ) : null}
        <BaseButton
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          sx={{
            maxWidth: "240px",
          }}
          onClick={handleSubmit((data) => {
            props.onConfirmClick(data);
          })}
        >
          確認する
        </BaseButton>
      </Stack>
    </Box>
  );
};
